/* BRIVO theme — behaviour only. Content comes from Liquid sections. */
(function () {
  "use strict";
  var S = (window.BRIVO && window.BRIVO.strings) || {};
  var FMT = (window.BRIVO && window.BRIVO.moneyFormat) || "{{amount_with_comma_separator}} €";

  /* ---------- money ---------- */
  function money(cents) {
    cents = Math.round(cents || 0);
    function num(dec, thou, places) {
      if (places === undefined) places = 2;
      var n = (cents / 100).toFixed(places);
      var parts = n.split(".");
      var i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return places ? i + dec + parts[1] : i;
    }
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case "amount": return num(".", ",");
        case "amount_no_decimals": return num("", ",", 0);
        case "amount_with_comma_separator": return num(",", " ");
        case "amount_no_decimals_with_comma_separator": return num("", " ", 0);
        case "amount_with_apostrophe_separator": return num(".", "'");
        case "amount_with_space_separator": return num(",", " ");
        case "amount_no_decimals_with_space_separator": return num("", " ", 0);
        default: return num(".", ",");
      }
    });
  }
  window.brivoMoney = money;

  /* ---------- toast + modal ---------- */
  var toastEl = document.getElementById("toast"), tTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add("show");
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { toastEl.classList.remove("show"); }, 2600);
  }
  var modal = document.getElementById("modal");
  function openModal(t, p) {
    if (!modal) return;
    document.getElementById("modalT").textContent = t || "";
    document.getElementById("modalP").textContent = p || "";
    modal.classList.add("show");
  }
  function closeModal() { if (modal) modal.classList.remove("show"); }
  if (modal) {
    document.getElementById("modalX").addEventListener("click", closeModal);
    modal.addEventListener("click", function (e) { if (e.target === modal) closeModal(); });
  }

  /* ---------- header ---------- */
  var hdr = document.getElementById("hdr");
  var burger = document.getElementById("burger");
  var mnav = document.getElementById("mnav");
  if (burger && mnav) {
    burger.addEventListener("click", function () {
      var open = mnav.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    Array.prototype.forEach.call(mnav.querySelectorAll("a"), function (a) {
      a.addEventListener("click", function () {
        mnav.classList.remove("open");
        burger.setAttribute("aria-expanded", "false");
      });
    });
  }

  /* ---------- sticky add to cart ---------- */
  var sticky = document.getElementById("stickyAtc");
  function onScroll() {
    if (hdr) hdr.classList.toggle("is-stuck", window.scrollY > 8);
    if (sticky) {
      var show = window.scrollY > 560 && window.innerWidth < 981;
      var last = document.querySelector(".final");
      if (last) {
        var r = last.getBoundingClientRect();
        if (r.top < window.innerHeight - 80) show = false;
      }
      sticky.classList.toggle("show", show);
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  onScroll();

  /* ---------- gallery ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-gallery]"), function (gal) {
    var media = gal.querySelectorAll(".gal__media");
    var thumbs = gal.querySelectorAll(".thumb");
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener("click", function () {
        var i = t.getAttribute("data-i");
        Array.prototype.forEach.call(thumbs, function (x) { x.classList.toggle("on", x === t); });
        Array.prototype.forEach.call(media, function (m) { m.classList.toggle("on", m.getAttribute("data-i") === i); });
      });
    });
  });

  /* ---------- before / after ---------- */
  function rnd(seed) { var s = seed; return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
  function hairs(seed, color, n, w) {
    var r = rnd(seed), out = "";
    for (var i = 0; i < n; i++) {
      var x = 14 + r() * 372, y = 14 + r() * 272, l = 16 + r() * 44, a = r() * Math.PI * 2,
          cx = x + Math.cos(a) * l * 0.5 + (r() - 0.5) * 22,
          cy = y + Math.sin(a) * l * 0.5 + (r() - 0.5) * 22,
          ex = x + Math.cos(a) * l, ey = y + Math.sin(a) * l;
      out += '<path d="M' + x.toFixed(1) + ' ' + y.toFixed(1) + ' Q' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ' ' + ex.toFixed(1) + ' ' + ey.toFixed(1) + '"/>';
    }
    return '<g stroke="' + color + '" stroke-width="' + w + '" fill="none" stroke-linecap="round" opacity=".85">' + out + '</g>';
  }
  function dots(seed, color, n) {
    var r = rnd(seed), out = "";
    for (var i = 0; i < n; i++) {
      out += '<circle cx="' + (10 + r() * 380).toFixed(1) + '" cy="' + (10 + r() * 280).toFixed(1) + '" r="' + (0.8 + r() * 2.1).toFixed(1) + '" fill="' + color + '" opacity="' + (0.3 + r() * 0.5).toFixed(2) + '"/>';
    }
    return out;
  }
  var FALLBACK = [
    { key: "sofa", base: "#C9BCA9", weave: "#B9A98F", struct: '<path d="M0 92h400M0 210h400M132 92v118M268 92v118" stroke="#AD9C81" stroke-width="2.5" fill="none"/><rect x="0" y="0" width="400" height="46" fill="#B9A890"/>', debris: hairs(11, "#3A2C22", 46, 1.9) + dots(7, "#5B4A3A", 40) },
    { key: "clothes", base: "#1B2332", weave: "#252F42", struct: '<g stroke="#2D3950" stroke-width="2.2" fill="none"><path d="M20 0v300M50 0v300M80 0v300M110 0v300M140 0v300M170 0v300M200 0v300M230 0v300M260 0v300M290 0v300M320 0v300M350 0v300M380 0v300"/></g>', debris: hairs(23, "#D8D2C6", 52, 1.8) + dots(31, "#EAE6DC", 46) },
    { key: "car", base: "#4A505A", weave: "#575E69", struct: '<path d="M0 66h400M0 238h400" stroke="#3D434C" stroke-width="3" fill="none"/><g stroke="#3D434C" stroke-width="2" stroke-dasharray="7 7" fill="none"><path d="M96 0v300M304 0v300"/></g>', debris: hairs(47, "#1B1B1B", 40, 1.9) + hairs(53, "#C7BBA6", 22, 1.6) + dots(59, "#9AA2AE", 52) }
  ];
  function fallbackSvg(f, uid, withDebris) {
    var id = "w" + uid + (withDebris ? "b" : "a");
    return '<svg viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice">' +
      '<defs><pattern id="' + id + '" width="8" height="8" patternUnits="userSpaceOnUse">' +
      '<rect width="8" height="8" fill="' + f.base + '"/>' +
      '<path d="M0 4h8M4 0v8" stroke="' + f.weave + '" stroke-width="1" opacity=".55"/></pattern></defs>' +
      '<rect width="400" height="300" fill="url(#' + id + ')"/>' + f.struct +
      (withDebris ? f.debris : "") + '</svg>';
  }
  Array.prototype.forEach.call(document.querySelectorAll(".ba__view"), function (view, idx) {
    var before = view.querySelector(".ba__layer--before");
    var after = view.querySelector(".ba__layer--after");
    if (before && !before.children.length) {
      var f = FALLBACK[idx % FALLBACK.length];
      before.innerHTML = fallbackSvg(f, idx, true);
      if (after && !after.children.length) after.innerHTML = fallbackSvg(f, idx, false);
    }
    var range = view.querySelector(".ba__range");
    if (range) range.addEventListener("input", function () { view.style.setProperty("--p", range.value + "%"); });
  });

  /* ---------- video cards ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-video-placeholder]"), function (b) {
    b.addEventListener("click", function () {
      openModal("Място за видео", "Отвори тази секция в Customizer-а и качи вертикален клип 9:16 (MP4) или постави линк към YouTube/Vimeo.");
    });
  });
  Array.prototype.forEach.call(document.querySelectorAll("[data-video-embed]"), function (b) {
    b.addEventListener("click", function () {
      var url = b.getAttribute("data-video-embed");
      var host = document.createElement("div");
      host.style.cssText = "position:absolute;inset:0;z-index:3";
      host.innerHTML = '<iframe src="' + url + '" allow="autoplay; fullscreen" allowfullscreen loading="lazy" title="Видео"></iframe>';
      b.appendChild(host);
      var p = b.querySelector(".vid__play"); if (p) p.style.display = "none";
    }, { once: true });
  });
  Array.prototype.forEach.call(document.querySelectorAll("[data-video-native]"), function (b) {
    b.addEventListener("click", function () {
      var v = b.querySelector("video");
      if (!v) return;
      if (v.paused) { v.play(); b.querySelector(".vid__play").style.display = "none"; }
      else { v.pause(); b.querySelector(".vid__play").style.display = ""; }
    });
  });

  /* ---------- cart ---------- */
  var cartEl = document.getElementById("cart"),
      scrim = document.getElementById("scrim"),
      cBody = document.getElementById("cartBody"),
      cShipBar = document.getElementById("cartShip"),
      cCount = document.getElementById("cartCount");
  var FREE = (window.BRIVO && window.BRIVO.freeShip) || 0;
  var R = (window.BRIVO) || {};

  function openCart() {
    if (!cartEl) return;
    cartEl.classList.add("open"); scrim.classList.add("show");
    cartEl.setAttribute("aria-hidden", "false");
  }
  function closeCart() {
    if (!cartEl) return;
    cartEl.classList.remove("open"); scrim.classList.remove("show");
    cartEl.setAttribute("aria-hidden", "true");
  }
  var cartBtn = document.getElementById("cartBtn");
  if (cartBtn && cartEl) cartBtn.addEventListener("click", function (e) { e.preventDefault(); openCart(); refresh(); });
  var cartX = document.getElementById("cartX"); if (cartX) cartX.addEventListener("click", closeCart);
  if (scrim) scrim.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeModal(); closeCart(); } });

  function drawCart(cart) {
    if (cCount) { cCount.textContent = cart.item_count; cCount.hidden = cart.item_count === 0; }
    if (!cBody) return;
    if (!cart.items.length) {
      cBody.innerHTML = '<p class="cart__empty">' + (S.empty || "") + '</p>';
    } else {
      cBody.innerHTML = cart.items.map(function (l) {
        var img = l.image
          ? '<img src="' + l.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") + '" alt="" loading="lazy">'
          : '<svg viewBox="0 0 420 420" width="52" height="52"><use href="#p-main"/></svg>';
        return '<div class="ci">' +
          '<span class="ci__img">' + img + '</span>' +
          '<span><span class="ci__t">' + l.product_title + '</span>' +
          '<span class="ci__m">' + l.quantity + ' × ' + money(l.final_price) + '</span>' +
          '<button class="ci__rm" data-key="' + l.key + '">' + (S.remove || "") + '</button></span>' +
          '<span class="ci__p">' + money(l.final_line_price) + '</span></div>';
      }).join("");
      Array.prototype.forEach.call(cBody.querySelectorAll("[data-key]"), function (b) {
        b.addEventListener("click", function () { change(b.getAttribute("data-key"), 0); });
      });
    }
    if (cShipBar) {
      if (!FREE) { cShipBar.hidden = true; }
      else if (cart.total_price <= 0) {
        cShipBar.innerHTML = "Безплатна доставка при поръчка над <b>" + money(FREE) + "</b>.<i style=\"--w:0%\"></i>";
      } else if (cart.total_price >= FREE) {
        cShipBar.innerHTML = '<b style="color:var(--ok)">' + (S.free || "") + '</b><i style="--w:100%"></i>';
      } else {
        cShipBar.innerHTML = "Още <b>" + money(FREE - cart.total_price) + "</b> " + (S.toFree || "") +
          '.<i style="--w:' + Math.min(100, cart.total_price / FREE * 100).toFixed(0) + '%"></i>';
      }
    }
    var sub = document.getElementById("cSub"); if (sub) sub.textContent = money(cart.items_subtotal_price);
    var tot = document.getElementById("cTot"); if (tot) tot.textContent = money(cart.total_price);
    var dRow = document.getElementById("cDiscRow");
    if (dRow) {
      var d = cart.total_discount || 0;
      dRow.hidden = d === 0;
      var dv = document.getElementById("cDisc"); if (dv) dv.textContent = "−" + money(d);
      var dl = document.getElementById("cDiscL");
      if (dl && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
        dl.textContent = "Отстъпка (" + cart.cart_level_discount_applications[0].title + ")";
      }
    }
  }

  function refresh() {
    return fetch(R.cartUrl + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { drawCart(c); return c; })
      .catch(function () {});
  }

  function change(key, qty) {
    return fetch(R.changeUrl + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { drawCart(c); }).catch(function () { toast(S.error); });
  }

  function addToCart(id, quantity, props, then) {
    var body = { items: [{ id: id, quantity: quantity }] };
    if (props) body.items[0].properties = props;
    return fetch(R.addUrl + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || S.error); });
      return r.json();
    }).then(function () {
      return refresh();
    }).then(function () {
      if (then === "checkout") { window.location.href = "/checkout"; return; }
      if (cartEl) { openCart(); } else { window.location.href = R.cartUrl; }
      toast(S.added);
    }).catch(function (e) { toast(e.message || S.error); });
  }
  window.brivoAdd = addToCart;
  if (cCount) refresh();

  /* ---------- product form ---------- */
  var form = document.getElementById("brivoProductForm");
  if (form) {
    var bundleWrap = document.getElementById("bundles");
    var qtyEl = document.getElementById("qty");
    var variantSelect = document.getElementById("variantSelect");
    var pxNow = document.getElementById("pxNow"), pxOld = document.getElementById("pxOld"), pxSave = document.getElementById("pxSave");
    var atcPrice = document.getElementById("atcPrice");
    var sLabel = document.getElementById("sLabel"), sPrice = document.getElementById("sPrice"), sOld = document.getElementById("sOld");
    var selected = null;

    function packs() { return Math.max(1, Math.min(20, parseInt(qtyEl ? qtyEl.value : 1, 10) || 1)); }
    function variantId() { return variantSelect ? variantSelect.value : form.getAttribute("data-variant"); }

    function pick(el) {
      if (!el) return;
      selected = el;
      Array.prototype.forEach.call(bundleWrap.querySelectorAll(".bundle"), function (x) {
        var on = x === el;
        x.classList.toggle("on", on);
        x.setAttribute("aria-checked", on ? "true" : "false");
      });
      render();
    }
    function tiers() {
      if (!bundleWrap) return [];
      return Array.prototype.map.call(bundleWrap.querySelectorAll(".bundle"), function (el) {
        return { qty: parseInt(el.getAttribute("data-qty"), 10) || 1,
                 unit: parseInt(el.getAttribute("data-unit"), 10) || 0 };
      }).sort(function (a, b) { return a.qty - b.qty; });
    }
    function render() {
      var unit = parseInt(form.getAttribute("data-price"), 10) || 0;
      var unitCmp = parseInt(form.getAttribute("data-compare"), 10) || unit;
      var qty = selected ? parseInt(selected.getAttribute("data-qty"), 10) : 1;
      var p = packs();
      var units = qty * p;
      /* Shopify applies the best quantity tier to the whole order, so price the
         same way: find the highest tier the total unit count reaches. */
      var list = tiers(), perUnit = selected ? parseInt(selected.getAttribute("data-unit"), 10) : unit;
      for (var i = 0; i < list.length; i++) { if (units >= list[i].qty) perUnit = list[i].unit; }
      var total = perUnit * units;
      var cmp = unitCmp * units;
      var save = cmp > total ? Math.round((1 - total / cmp) * 100) : 0;
      if (pxNow) pxNow.textContent = money(total);
      if (pxOld) { pxOld.textContent = money(cmp); pxOld.hidden = cmp <= total; }
      if (pxSave) { pxSave.textContent = "−" + save + "%"; pxSave.hidden = save <= 0; }
      if (atcPrice) atcPrice.textContent = money(total);
      if (sLabel) sLabel.textContent = units + "× " + form.getAttribute("data-name");
      if (sPrice) sPrice.textContent = money(total);
      if (sOld) { sOld.textContent = money(cmp); sOld.hidden = cmp <= total; }
    }

    if (bundleWrap) {
      Array.prototype.forEach.call(bundleWrap.querySelectorAll(".bundle"), function (el) {
        el.addEventListener("click", function () { pick(el); });
        el.addEventListener("keydown", function (e) {
          if (e.key === " " || e.key === "Enter") { e.preventDefault(); pick(el); }
        });
      });
      pick(bundleWrap.querySelector(".bundle.on") || bundleWrap.querySelector(".bundle"));
    } else { render(); }

    var qMinus = document.getElementById("qMinus"), qPlus = document.getElementById("qPlus");
    if (qMinus) qMinus.addEventListener("click", function () { qtyEl.value = Math.max(1, packs() - 1); render(); });
    if (qPlus) qPlus.addEventListener("click", function () { qtyEl.value = Math.min(20, packs() + 1); render(); });
    if (qtyEl) qtyEl.addEventListener("input", render);
    if (variantSelect) variantSelect.addEventListener("change", function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      form.setAttribute("data-price", opt.getAttribute("data-price"));
      form.setAttribute("data-compare", opt.getAttribute("data-compare"));
      render();
    });

    function submit(then) {
      var id = variantId();
      if (!id) { toast(S.soldout); return; }
      var qty = (selected ? parseInt(selected.getAttribute("data-qty"), 10) : 1) * packs();
      var props = null;
      if (selected && selected.getAttribute("data-gift")) {
        props = { "Подарък": selected.getAttribute("data-gift") };
      }
      addToCart(id, qty, props, then);
    }
    var atc = document.getElementById("atc"); if (atc) atc.addEventListener("click", function (e) { e.preventDefault(); submit(); });
    var buyNow = document.getElementById("buyNow"); if (buyNow) buyNow.addEventListener("click", function (e) { e.preventDefault(); submit("checkout"); });
    var sBtn = document.getElementById("sBtn"); if (sBtn) sBtn.addEventListener("click", function (e) { e.preventDefault(); submit(); });

    /* promo field — stores the code and applies it at checkout */
    var promoT = document.getElementById("promoT"), promoB = document.getElementById("promoB"), promoM = document.getElementById("promoM");
    if (promoT && promoB) {
      promoT.addEventListener("click", function () {
        var open = promoB.classList.toggle("open");
        promoT.setAttribute("aria-expanded", open ? "true" : "false");
        if (open) document.getElementById("promoI").focus();
      });
      document.getElementById("promoGo").addEventListener("click", function () {
        var v = document.getElementById("promoI").value.trim();
        promoM.classList.add("show");
        if (!v) { promoM.className = "promo__msg show err"; promoM.textContent = "Въведи код."; return; }
        try { sessionStorage.setItem("brivo_discount", v); } catch (e) {}
        promoM.className = "promo__msg show ok";
        promoM.textContent = "Кодът " + v.toUpperCase() + " ще бъде приложен при плащане.";
      });
    }
  }

  /* carry a stored discount code into checkout */
  var checkoutBtns = document.querySelectorAll("[data-checkout]");
  Array.prototype.forEach.call(checkoutBtns, function (b) {
    b.addEventListener("click", function (e) {
      var code = null;
      try { code = sessionStorage.getItem("brivo_discount"); } catch (err) {}
      if (code) { e.preventDefault(); window.location.href = "/checkout?discount=" + encodeURIComponent(code); }
    });
  });

  /* ---------- cart page quantity controls ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-line-qty]"), function (box) {
    var key = box.getAttribute("data-line-qty");
    var input = box.querySelector("input");
    box.querySelector("[data-minus]").addEventListener("click", function () {
      var v = Math.max(0, (parseInt(input.value, 10) || 1) - 1);
      window.location.href = R.changeUrl + "?id=" + encodeURIComponent(key) + "&quantity=" + v;
    });
    box.querySelector("[data-plus]").addEventListener("click", function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      window.location.href = R.changeUrl + "?id=" + encodeURIComponent(key) + "&quantity=" + v;
    });
  });
})();
